module.exports = __webpack_public_path__ + "dingbeauty/admin/img/lineFriend_3.af12a6f4.jpg";